import { useMutation as useReactMutation } from '@tanstack/react-query'
import { useMemo } from 'react'

import { queryClient } from '../index'
import { flatten, join, values } from 'lodash'

const baseUrl = "/api"

export default function useMutation(key: string, id: string | null = null, method: string | null = null) {
  const url = id ? `${baseUrl}/${key}/${id}/` : `${baseUrl}/${key}/`
  const requestMethod = method || id ? "PATCH" : "POST"

  const mutationFn = async (data: any) => {
    const headers = {
      "Content-Type": "application/json",
      "Authorization": `Token ${localStorage.getItem("token")}`,
    }
    const response = await fetch(
      url,
      { method: requestMethod, headers, body: JSON.stringify(data) }
    )

    if (!response.ok) {
      let json
      let errorMessage
      try {
        json = await response.json()
        errorMessage = join(flatten(values(json)))
      } catch (error) {
        errorMessage = "An unknown error occurred."
      }
      
      throw new Error(errorMessage)
    }

    const json = await response.json()
    return json
  }

  const onSuccess = () => {
    queryClient.invalidateQueries({ queryKey: [key] })
  }
  const onError = (error: any) => console.log(error)
  const mutation = useReactMutation({
    mutationFn,
    onSuccess,
    onError,
  })

  return useMemo(() => mutation, [mutation])
}
